import React, {useState} from "react";
import "./AdminLogin.css";

const ADMIN_USER = process.env.REACT_APP_ADMIN_USERNAME || "admin";
const ADMIN_PASS = process.env.REACT_APP_ADMIN_PASSWORD || "admin@123";
const SESSION_KEY = "ve_admin_auth";

export function isAdminLoggedIn() {
  return sessionStorage.getItem(SESSION_KEY) === "true";
}

export function adminLogout() {
  sessionStorage.removeItem(SESSION_KEY);
  window.location.href = "/admin/login";
}

export default function AdminLogin({onLogin}) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Simulate a small delay so it doesn't feel instant
    setTimeout(() => {
      if (username.trim() === "savan" && password === "variant@123") {
        sessionStorage.setItem(SESSION_KEY, "true");
        onLogin();
      } else {
        setError("Invalid username or password.");
        setLoading(false);
      }
    }, 600);
  }

  return (
    <div className="login-page">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <span className="login-logo-mark">◆</span>
          <span className="login-logo-text">Variant Exclusive</span>
        </div>

        <h1 className="login-title">Admin Login</h1>
        <p className="login-sub">Sign in to manage your store</p>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
                setError("");
              }}
              placeholder="Enter username"
              autoFocus
              autoComplete="username"
            />
          </div>

          <div className="login-field">
            <label>Password</label>
            <div className="pass-wrap">
              <input
                type={showPass ? "text" : "password"}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError("");
                }}
                placeholder="Enter password"
                autoComplete="current-password"
              />
              <button
                type="button"
                className="pass-toggle"
                onClick={() => setShowPass((s) => !s)}
                tabIndex={-1}
              >
                {showPass ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          {error && <div className="login-error">⚠️ {error}</div>}

          <button
            type="submit"
            className="login-btn"
            disabled={loading || !username || !password}
          >
            {loading ? "Signing in…" : "Sign In →"}
          </button>
        </form>

        <p className="login-footer">
          <a
            href="/"
            style={{color: "#9ca3af", fontSize: 13, textDecoration: "none"}}
          >
            ← Back to store
          </a>
        </p>
      </div>
    </div>
  );
}
